<template>
  <div class="row m-4">
    <div class="col-12 col-md-3 mb-3" v-for="(item,i) of templateList" :key="i">
      <div class="box purple border rounded-3 overflow-hidden">
        <div class="position-relative box showOnHover">
          <K2Button theme="2" size="small" class="box d-table absolute center hoverChild" @onclick="handleSelectTemplate(item)">
            {{lang("Use")}}
          </K2Button>
          <div v-if="item.postFile">
            <img style="height: 200px; overflow: hidden; width: 100%; object-fit: contain; background: white"
                 v-if="item.postFile[0].PostItemFileType === 'video/mp4'"
                 :src="assets.image.videoThumb"/>
            <img style="height: 200px; overflow: hidden; width: 100%; object-fit: cover;"
                 v-else :src="item.postFile[0].FilePath"/>
          </div>
          <div style="height: 200px; overflow: hidden; width: 100%;background: black" v-else/>
        </div>
        <div class="p-3">
          <strong>{{ item.PostUpdDtlTitle }}</strong>
          <K2Row align="flex-end" space-between="true">
            <div>
              <K2Text :color="uiVariable.color.purple" v-if="item.POSTCONTENT">{{ item.POSTCONTENT.substring(0,22) }}...</K2Text>
              <K2Text :color="uiVariable.color.purple" v-else-if="item.PostUpdDtlDescription">{{ item.PostUpdDtlDescription.substring(0,22) }}...</K2Text><br/>
              <K2Text>{{ item.POSTCREATEDDATE_CONVERT }}</K2Text>
            </div>
<!--            <K2Icon name="delete" :color="uiVariable.color.error" link="true" @onclick="removeItemAt(i)"/>-->
            <K2Confirm :title="lang('Are you sure you want to discard this template')" no-children="true"
                       theme="3" @confirm="deletePost(item)"
                       icon="delete"/>
          </K2Row>
        </div>
      </div>

    </div>
    <K2Row justify_content="center" v-if="templateList && templateList.length>=8">
      <el-pagination
          layout="next"
          :next-text="lang('Show More')"
          @next-click="handleNext">
      </el-pagination>
    </K2Row>
  </div>
</template>

<script>
import K2Icon from "../../../uiComponents/k2Icon/k2MAIcon";
import K2Row from "../../../uiComponents/k2Row/k2Row";
import uiVariable from "../../../config/uiVariable";
import DataSource from "../../../data/datasource";
import K2Button from "../../../uiComponents/k2Button/k2Button";
import $ from "jquery";
import K2Text from "../../../uiComponents/k2Text/k2Text";
import assets from "../../../assets/assets"
import K2Confirm from "../../../uiComponents/k2Confirm/k2Confirm";
import {lang} from "../../../locale";

export default {
  name: "activityTemplate",
  components: {K2Confirm, K2Text, K2Button, K2Row},
  props: ["handleClose", "modal", "useTemplate", "templateList", "getTemplate"],
  data() {
    return {
      assets: assets,
      uiVariable: uiVariable,
      isTemplate: true,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    lang,
    async init() {
      this.isTemplate = this.modal === "Template";
    },
    showLoading() {
      this.$vs.loading();
    },
    hideLoading() {
      this.$vs.loading.close();
    },
    removeItemAt(index) {
      this.templateList.splice(index, 1);
    },
    handleSelectTemplate(item) {
      this.$emit("useTemplate", item)
    },
    handleNext() {
      this.$emit("getTemplate", this.modal, this.templateList.length)
    },
    convertDatetimeFormat(datetimeVal) {
      return moment(datetimeVal).format("DD/MM/YYYY HH:mm");
      // return moment(datetimeVal).format("DD/MM/YYYY HH:mm:ss");
    },
    async deletePost(post) {
      const response = await DataSource.shared.softDeletePost(post.POSTID);
      if (response) {
        if (response.code === '88') {
          window.location.replace('/');
        } else if (response.code === '99') {
          console.log('getPlannerAssignedStudentsGroupByClassID Error');
        } else if (response.code === '2') {
          console.log('getPlannerAssignedStudentsGroupByClassID no record');
        } else {
          this.$emit("getTemplate")
        }
      }
    },
  },
}
</script>